module.exports = __webpack_public_path__ + "static/media/placementbar.ea81f70c.png";